export function adminSections(permissions = {}) {
  return [
    { id: 'approvals', label: 'Companies & approvals', allowed: permissions.manageHcRouting || permissions.manageCcdApprovers },
    { id: 'policy', label: 'Workflow settings', allowed: permissions.managePolicy },
    { id: 'notifications', label: 'Notifications', allowed: permissions.manageNotifications },
    { id: 'access', label: 'Access & roles', allowed: permissions.viewAccess },
    { id: 'security', label: 'Security status', allowed: permissions.viewSecurity },
  ].filter(section => section.allowed === true);
}

export function adminSessionSettings(settings, editing) {
  if (!settings || !settings.permissions?.viewAccess || editing) return settings;
  return { ...settings, readOnly: true, writeStatus: settings.writeStatus === 'ready' ? 'locked_superadmin_session' : settings.writeStatus };
}
